
import React from 'react';
import { withRouter } from 'react-router';
import { withTheme } from 'styled-components';
import { Box, Layer, ResponsiveContext, Text } from 'grommet';

import CellLink from './CellLink';
import CellTitle from './CellTitle';
import DataTable from './DataTable';
import Loading from './Loading';
import TratFilter from './trat/TratFilter';
import ShowInMapLink from './map/ShowInMapLink';

function getColumns(size) {
    let columns = [];
    if (size !== 'small') {
        columns.push({
            property: 'podoblast',
            header: <CellTitle title="Podoblast" />,
            search: false
        });
    }
    columns.push({
        property: 'obec',
        header: <CellTitle title="Obec" />,
        search: false
    });
    if (size !== 'small') {
        columns.push({
            property: 'katastr',
            header: <CellTitle title="Katastr" />,
            search: false
        });
    }
    columns.push({
        property: 'trat',
        header: <CellTitle title="Trať" />,
        render: row => (
            <CellLink size="medium" title={row.trat} link={`trat/${row.id}`} />
        ),
        search: false
    });
    return columns;
}

const FilteringLayer = () => {
    return (
        <Layer>
            <Loading />
        </Layer>
    )
}

const FilterStatusInfo = ({countAll, countFiltered}) => {
    if (countFiltered !== countAll) {
        if (countFiltered === 0) {
            return <FilterStatusText text="Zadaným podmínkám nevyhovuje žádná viniční trať" />;
        } else {
            return <FilterStatusText text={`Zobrazeno ${countFiltered} z celkem ${countAll} viničních tratí`} />;
        }
    } else {
        return null;
    }
}

const FilterStatusText = ({text}) => {
    return (
        <Box pad="3px">
            <Text color="dark-4">{text}</Text>
        </Box>
    );
}

const TratListData = ({size, setMapPoints, tratList}) => {
    let points = tratList.map(item => {
        return {
            x: item.x,
            y: item.y,
            title: item.trat
        };
    });

    return (
        <Box>
            <DataTable
                columns={getColumns(size)}
                data={tratList}
                primaryKey="id"
            />
            <ShowInMapLink
                points={points}
                setMapPoints={setMapPoints}
            />
        </Box>
    );
}

const TratList = ({countAll, tratList, tratFilter, tratOdrudaList, onFilterChange, setMapPoints, history}) => {
    return (
        <ResponsiveContext.Consumer>
            {(size) => {
                return (
                    <Box>
                        {(tratFilter.loading)
                            ? <FilteringLayer />
                            : null
                        }
                        <TratFilter
                            attributes={tratFilter}
                            tratOdrudaList={tratOdrudaList}
                            onChange={onFilterChange}
                        />
                        <FilterStatusInfo
                            countAll={countAll}
                            countFiltered={tratList.length}
                        />
                        {(tratList.length > 0)
                            ? (
                                <TratListData
                                    tratList={tratList}
                                    size={size}
                                    setMapPoints={setMapPoints}
                                />
                            )
                            : null
                        }
                    </Box>
                );
            }}
        </ResponsiveContext.Consumer>
    );
}

export default withTheme(withRouter(TratList));
